import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ark-lib-multiplier-modal',
  templateUrl: './multiplier-modal.component.html',
  styleUrls: ['./multiplier-modal.component.css'],
})
export class MultiplierModalComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
